import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_5e258ebd-49b8-4be0-854e-388039fa29ef/artifacts/xz5s5dku_IZIWHITE.png"
              alt="IZI Travels"
              className="h-28 w-auto mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('tagline')}
            </p>
            {/* Social Media */}
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/IZITravelsRDC"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="Facebook"
                data-testid="footer-facebook-link"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/izi.travels"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="X (Twitter)"
                data-testid="footer-twitter-link"
              >
                <Twitter size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="LinkedIn"
                data-testid="footer-linkedin-link"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">{t('quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('accueil')}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-left"
                >
                  {t('home')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('destinations')}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-left"
                >
                  {t('destinations')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('compagnies')}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-left"
                >
                  {t('airlines')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-left"
                >
                  {t('services')}
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6">{t('ourServicesFooter')}</h3>
            <ul className="space-y-3 text-gray-400">
              <li>{t('nationalTickets')}</li>
              <li>{t('internationalTickets')}</li>
              <li>{t('travelAssistance')}</li>
              <li>{t('personalizedAdvice')}</li>
              <li>{t('quickBooking')}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">{t('contact')}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={20} className="flex-shrink-0 mt-1 text-blue-400" />
                <span>
                  225, Avenue Du Progrès<br />
                  Bon Marché, Barumbu<br />
                  Kinshasa, RD Congo
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Phone size={20} className="flex-shrink-0 text-blue-400" />
                <a href="tel:+243823060716" className="hover:text-white transition-colors duration-200">
                  +243 823 060 716
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Mail size={20} className="flex-shrink-0 text-blue-400" />
                <a href="mailto:contact@izitravels.net" className="hover:text-white transition-colors duration-200">
                  contact@izitravels.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {currentYear} IZI Travels. {t('allRightsReserved')}
          </p>
          <p className="text-blue-400 font-semibold mt-2">
            {t('footerSignature')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
